"use client";

import { cartSchema } from "../../../lib/types/schema/subscription/cartSchema";
import { useRequestMutation } from "../../../request/hooks/useRequestMutation";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyCart } from "./keyCart";

type CartProps = UseRequestQueryProps & {
  isQuery?: boolean;
  priceId?: string;
  promoCode?: string;
};

export const useRequestCart = ({
  isQuery = true,
  priceId,
  promoCode,
  ...props
}: CartProps) => {
  return {
    query: useRequestQuery<typeof cartSchema>({
      enabled: isQuery && typeof priceId === "string" && priceId.length > 0,
      queryFnRequestProps: {
        schema: cartSchema,
        urlBackendPath: `/cart?price_id=${priceId ?? ""}${promoCode ? `&promo_code=${promoCode}` : ""}`,
      },
      queryKey: keyCart({ priceId, promoCode }),
      ...props,
    }),
    checkCart: useRequestMutation({
      mutationFnRequestProps: ({
        promoCode,
      }: Pick<CartProps, "promoCode">) => ({
        enabled: typeof priceId === "string" && priceId.length > 0,
        schema: cartSchema,
        urlBackendPath: `/cart?price_id=${priceId ?? ""}${promoCode ? `&promo_code=${promoCode}` : ""}`,
        method: "GET",
      }),
    }),
  };
};
